import { SortInfo } from 'types/pagination';

const SSDLC_SHOW_ALL_TOOLS = 'SSDLC_SHOW_ALL_TOOLS';
const GROUPS_VIEW_RISK_SCORE = 'groups-view-riskscore';
const GROUPS_VIEW_FINDING_COUNT = 'groups-view-findings';
const GROUPS_VIEW_RISK_SCORE_FOR_TABLE = 'groups-view-riskscore-for-table';
const GROUPS_VIEW_FINDING_COUNT_FOR_TABLE = 'groups-view-findings-for-table';
const GROUPS_VIEW_TOOL_STATUS_FOR_TABLE = 'groups-view-tool-status-for-table';
const FINDING_MODAL_PINNED_FIELDS = 'finding-modal-pinned-fields';
const GROUPS_VIEW_LEFT_PANEL_WIDTH = 'groups-view-left-panel-width';
const HIDE_PRIVATE_DASHBOARD = 'HIDE_PRIVATE_DASHBOARD';
const AC_SIDE_MENU_COLLAPSE_STATUS = 'ac-side-menu-collapse-status';
const SSDLC_HEALTHCHECK_DASHBOARD_VIEW = 'SSDLC-healthcheck-dashboard-view';
const ALL_BU_DASHBOARD_VIEW = 'all-BU-dashboard-view';
const SSDLC_HEALTHCHECK_DASHBOARD_TOOLS_VIEW_HIDE_EMPTY_ROWS =
  'SSDLC-healthcheck-dashboard-tools-view-hide-empty-rows';
const FINDING_DETAILS_SIDEBAR_COLLAPSED_KEYS =
  'ac-finding-details-sidebar-collapsed-keys';
const START_GROUPING_COLLAPSED = 'start-grouping-collapsed';
const ONBOARDING_MENU_COLLAPSED = 'onboarding-menu-collapsed';
const ASSESSMENT_DETAILS_SIDEBAR_COLLAPSED_KEYS =
  'ac-finding-details-sidebar-collapsed-keys';
const FINDING_DETAILS_TAGS_SORT_INFO = 'finding-details-tags-sort-info';
const FINDING_DETAILS_HIDE_ARMORCODE_TAGS =
  'ac-finding-details-hide-armorcode-tags';
const PRODUCT_DETAILS_HIDE_ARMORCODE_TAGS =
  'ac-product-details-hide-armorcode-tags';
const FINDING_TAG_SHOW_ALL_FILTERED_TAGS = 'finding-tag-show-all-filtered-tags';
const GROUP_ACTIVITY_LAST_TAB = 'group-activity-last-tab';
const SUBGROUP_ACTIVITY_LAST_TAB = 'subgroup-activity-last-tab';
const ANYA_HISTORY_OPEN_STATE = 'anya-history-open-state';
const IS_HIGH_CONTRAST_MODE = 'is-high-contrast-mode';

export const OUT_OF_BOX_DATE = 'outOfBoxDate';
export const ANYA_DRAFT_KEY = 'anya-chat-draft';

export const setLocalStorage = <T>(key: string, data: T): void => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const deleteLocalStorage = (key: string): void => {
  localStorage.removeItem(key);
};

export const getLocalStorage = <T>(key: string, defaultValue?: T): T => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return defaultValue === undefined ? ({} as T) : defaultValue;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined as unknown as T;
  }
};

export function setSSDLCShowAllTools(value: boolean): void {
  return setLocalStorage(SSDLC_SHOW_ALL_TOOLS, value);
}

export function getSSDLCShowAllTools(): boolean {
  return getLocalStorage<boolean>(SSDLC_SHOW_ALL_TOOLS, false);
}

export function setGroupsViewShowRiskScore(value: boolean): void {
  return setLocalStorage(GROUPS_VIEW_RISK_SCORE, value);
}

export function getGroupsViewShowRiskScore(): boolean {
  return getLocalStorage<boolean>(GROUPS_VIEW_RISK_SCORE, false);
}

export function setGroupsViewShowFindingCount(value: boolean): void {
  return setLocalStorage(GROUPS_VIEW_FINDING_COUNT, value);
}

export function getGroupsViewShowFindingCount(): boolean {
  return getLocalStorage<boolean>(GROUPS_VIEW_FINDING_COUNT, false);
}

export function getPrivateHideDashboard(): boolean {
  return getLocalStorage<boolean>(HIDE_PRIVATE_DASHBOARD, false);
}

export function setPrivateHideDashboard(value: boolean): void {
  return setLocalStorage(HIDE_PRIVATE_DASHBOARD, value);
}

// Stored data to show/hide riskscore, finding count & tool status
// for group details right panel
export function setGroupsViewShowRiskScoreForTable(value: boolean): void {
  return setLocalStorage(GROUPS_VIEW_RISK_SCORE_FOR_TABLE, value);
}

export function getGroupsViewShowRiskScoreForTable(): boolean {
  return getLocalStorage<boolean>(GROUPS_VIEW_RISK_SCORE_FOR_TABLE, true);
}

export function setGroupsViewShowFindingCountForTable(value: boolean): void {
  return setLocalStorage(GROUPS_VIEW_FINDING_COUNT_FOR_TABLE, value);
}

export function getGroupsViewShowFindingCountForTable(): boolean {
  return getLocalStorage<boolean>(GROUPS_VIEW_FINDING_COUNT_FOR_TABLE, true);
}

export function setGroupsViewShowToolStatusForTable(value: boolean): void {
  return setLocalStorage(GROUPS_VIEW_TOOL_STATUS_FOR_TABLE, value);
}

export function getGroupsViewShowToolStatusForTable(): boolean {
  return getLocalStorage<boolean>(GROUPS_VIEW_TOOL_STATUS_FOR_TABLE, false);
}

export function setFingModalPinnedFields(value: string[]): void {
  return setLocalStorage(FINDING_MODAL_PINNED_FIELDS, value);
}

export function getFingModalPinnedFields(): string[] {
  return getLocalStorage<string[]>(FINDING_MODAL_PINNED_FIELDS, []);
}

export function setGroupsViewLeftPanelWidth(value: number | null): void {
  return setLocalStorage(GROUPS_VIEW_LEFT_PANEL_WIDTH, value);
}

export function getGroupsViewLeftPanelWidth(): number | null {
  return getLocalStorage<number | null>(GROUPS_VIEW_LEFT_PANEL_WIDTH, null);
}

export function setACSideMenuCollpaseStatus(value: boolean): void {
  return setLocalStorage(AC_SIDE_MENU_COLLAPSE_STATUS, value);
}

export function getACSideMenuCollpaseStatus(): boolean {
  return getLocalStorage<boolean>(AC_SIDE_MENU_COLLAPSE_STATUS, false);
}

export function setSSDLCHealthCheckDashboardView(value: string): void {
  return setLocalStorage(SSDLC_HEALTHCHECK_DASHBOARD_VIEW, value);
}

export function getSSDLCHealthCheckDashboardView(): string {
  return getLocalStorage<string>(
    SSDLC_HEALTHCHECK_DASHBOARD_VIEW,
    'FINDINGS_VIEW',
  );
}

export function setAllBUDashboardView(value: string): void {
  return setLocalStorage(ALL_BU_DASHBOARD_VIEW, value);
}

export function getAllBUDashboardView(): string {
  return getLocalStorage<string>(ALL_BU_DASHBOARD_VIEW, 'FINDINGS_VIEW');
}

export function setSSDLCHealthCheckDashboardToolsViewHideEmptyRows(
  value: boolean,
): void {
  return setLocalStorage(
    SSDLC_HEALTHCHECK_DASHBOARD_TOOLS_VIEW_HIDE_EMPTY_ROWS,
    value,
  );
}

export function getSSDLCHealthCheckDashboardViewHideEmptyRows(): boolean {
  return getLocalStorage<boolean>(
    SSDLC_HEALTHCHECK_DASHBOARD_TOOLS_VIEW_HIDE_EMPTY_ROWS,
    true,
  );
}

export function setFindingDetailsSidebarCollapsedKeys(value: string[]): void {
  return setLocalStorage(FINDING_DETAILS_SIDEBAR_COLLAPSED_KEYS, value);
}

export function getFindingDetailsSidebarCollapsedKeys(
  value?: string[],
): string[] {
  return getLocalStorage<string[]>(
    FINDING_DETAILS_SIDEBAR_COLLAPSED_KEYS,
    value,
  );
}

export function setAssessmentDetailsSidebarCollapsedKeys(
  value: string[],
): void {
  return setLocalStorage(ASSESSMENT_DETAILS_SIDEBAR_COLLAPSED_KEYS, value);
}

export function getAssessmentDetailsSidebarCollapsedKeys(
  value?: string[],
): string[] {
  return getLocalStorage<string[]>(
    ASSESSMENT_DETAILS_SIDEBAR_COLLAPSED_KEYS,
    value,
  );
}

export function setStartGroupingCollapsed(value: boolean): void {
  return setLocalStorage(START_GROUPING_COLLAPSED, value);
}

export function getStartGroupingCollapsed(): boolean {
  return getLocalStorage<boolean>(START_GROUPING_COLLAPSED, false);
}

export function setOnboardingMenuCollapsed(value: boolean): void {
  return setLocalStorage(ONBOARDING_MENU_COLLAPSED, value);
}

export function getOnboardingMenuCollapsed(): boolean {
  return getLocalStorage<boolean>(ONBOARDING_MENU_COLLAPSED, true);
}

export function setFindingDetailsTagsSortInfo(value: SortInfo): void {
  return setLocalStorage(FINDING_DETAILS_TAGS_SORT_INFO, value);
}

export function getFindingDetailsTagsSortInfo(): SortInfo {
  return getLocalStorage<SortInfo>(FINDING_DETAILS_TAGS_SORT_INFO, {
    key: 'ascend',
  });
}

export function setFindingDetailsHideArmorCodeTags(value: boolean): void {
  return setLocalStorage(FINDING_DETAILS_HIDE_ARMORCODE_TAGS, value);
}

export function getFindingDetailsHideArmorCodeTags(): boolean {
  return getLocalStorage<boolean>(FINDING_DETAILS_HIDE_ARMORCODE_TAGS, true);
}

export function setProductDetailsHideArmorCodeTags(value: boolean): void {
  return setLocalStorage(PRODUCT_DETAILS_HIDE_ARMORCODE_TAGS, value);
}

export function getProductDetailsHideArmorCodeTags(): boolean {
  return getLocalStorage<boolean>(PRODUCT_DETAILS_HIDE_ARMORCODE_TAGS, true);
}

export function setShowAllFindingTag(value: boolean): void {
  return setLocalStorage(FINDING_TAG_SHOW_ALL_FILTERED_TAGS, value);
}

export function getShowAllFindingTag(): boolean {
  return getLocalStorage<boolean>(FINDING_TAG_SHOW_ALL_FILTERED_TAGS, false);
}

const AC_EXPANDABLE_SEARCH_ARMORCODE_SUBGROUP_PRODUCT =
  'ac-expandable-search-armorcode-group-subproduct';
const AC_EXPANDABLE_SEARCH_ARMORCODE_GROUP_PRODUCT =
  'ac-expandable-search-armorcode-group-product';

export function setArmorcodeGroupProductSearchExpanded(value: boolean): void {
  return setLocalStorage(AC_EXPANDABLE_SEARCH_ARMORCODE_GROUP_PRODUCT, value);
}

export function getArmorcodeGroupProductSearchExpanded(): boolean {
  return getLocalStorage<boolean>(
    AC_EXPANDABLE_SEARCH_ARMORCODE_GROUP_PRODUCT,
    false,
  );
}
export function setArmorcodeGroupSubProductSearchExpanded(
  value: boolean,
): void {
  return setLocalStorage(
    AC_EXPANDABLE_SEARCH_ARMORCODE_SUBGROUP_PRODUCT,
    value,
  );
}

export function getArmorcodeGroupSubProductSearchExpanded(): boolean {
  return getLocalStorage<boolean>(
    AC_EXPANDABLE_SEARCH_ARMORCODE_SUBGROUP_PRODUCT,
    false,
  );
}

export function setExceptionDetailsSidebarCollapsedKeys(value: string[]): void {
  return setLocalStorage(FINDING_DETAILS_SIDEBAR_COLLAPSED_KEYS, value);
}

export function getExceptionDetailsSidebarCollapsedKeys(
  value?: string[],
): string[] {
  return getLocalStorage<string[]>(
    FINDING_DETAILS_SIDEBAR_COLLAPSED_KEYS,
    value,
  );
}

export function setGroupActivityLastTab(value: string): void {
  return setLocalStorage(GROUP_ACTIVITY_LAST_TAB, value);
}

export function getGroupActivityLastTab(): string {
  return getLocalStorage<string>(GROUP_ACTIVITY_LAST_TAB, 'artifacts');
}

export function setSubgroupActivityLastTab(value: string): void {
  return setLocalStorage(SUBGROUP_ACTIVITY_LAST_TAB, value);
}

export function getSubgroupActivityLastTab(): string {
  return getLocalStorage<string>(SUBGROUP_ACTIVITY_LAST_TAB, 'artifacts');
}

const FINDING_DETAILS_LAST_TAB = 'finding-details-last-tab';
const FINDING_DETAILS_OVERVIEW_LAST_TAB = 'finding-details-overview-last-tab';

export function setFindingDetailsLastTab(value: string): void {
  return setLocalStorage(FINDING_DETAILS_LAST_TAB, value);
}

export function getFindingDetailsLastTab(): string {
  return getLocalStorage<string>(FINDING_DETAILS_LAST_TAB, 'general');
}

export function setFindingDetailsOverviewLastTab(value: string): void {
  return setLocalStorage(FINDING_DETAILS_OVERVIEW_LAST_TAB, value);
}

export function getFindingDetailsOverviewLastTab(): string {
  return getLocalStorage<string>(FINDING_DETAILS_OVERVIEW_LAST_TAB, 'details');
}

export function getAnyaDraft(): string {
  return getLocalStorage<string>(ANYA_DRAFT_KEY, '');
}

export function setAnyaDraft(draft: string): void {
  setLocalStorage(ANYA_DRAFT_KEY, draft);
}

export function clearAnyaDraft(): void {
  deleteLocalStorage(ANYA_DRAFT_KEY);
}

/**
 * Removes all column size customizations from localStorage.
 * Column sizes are stored with keys ending in "_column_size".
 */
export function resetAllColumnSizes(): void {
  const keysToRemove: string[] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.endsWith('_column_size')) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => {
    localStorage.removeItem(key);
  });
}

const PRODUCT_PREVIEW_KEY = 'product-lst-preview';
export function getProductPreviewEnabled() {
  return getLocalStorage(PRODUCT_PREVIEW_KEY, true);
}
export function setProductPreviewEnabled(status: boolean) {
  setLocalStorage(PRODUCT_PREVIEW_KEY, status);
}
const SUB_PRODUCT_PREVIEW_KEY = 'subproduct-lst-preview';
export function getSubProductPreviewEnabled() {
  return getLocalStorage(SUB_PRODUCT_PREVIEW_KEY, true);
}
export function setSubProductPreviewEnabled(status: boolean) {
  setLocalStorage(SUB_PRODUCT_PREVIEW_KEY, status);
}
const EXCEPTION_PREVIEW_KEY = 'exception-list-preview';
export function getExceptionPreviewEnabled(): boolean {
  return getLocalStorage<boolean>(EXCEPTION_PREVIEW_KEY, true);
}
export function setExceptionPreviewEnabled(status: boolean): void {
  setLocalStorage(EXCEPTION_PREVIEW_KEY, status);
}
const USER_MANAGEMENT_PREVIEW_KEY = 'user-management-list-preview';
export function getUserManagementPreviewEnabled(): boolean {
  return getLocalStorage<boolean>(USER_MANAGEMENT_PREVIEW_KEY, true);
}
export function setUserManagementPreviewEnabled(status: boolean): void {
  setLocalStorage(USER_MANAGEMENT_PREVIEW_KEY, status);
}

export function getAnyaHistoryOpenState(): boolean {
  return getLocalStorage<boolean>(ANYA_HISTORY_OPEN_STATE, true);
}
export function setAnyaHistoryOpenState(status: boolean): void {
  setLocalStorage(ANYA_HISTORY_OPEN_STATE, status);
}

const ANYA_BUBBLE_CORNER = 'anya-bubble-corner';

export function getAnyaBubbleCorner<T extends string>(defaultValue: T): T {
  return getLocalStorage<T>(ANYA_BUBBLE_CORNER, defaultValue);
}

export function setAnyaBubbleCorner<T extends string>(corner: T): void {
  setLocalStorage(ANYA_BUBBLE_CORNER, corner);
}

// ─── Anya Agents View Mode ──────────────────────────────

const ANYA_AGENTS_VIEW_MODE = 'anya-agents-view-mode';

export function getAnyaAgentsViewMode(): 'grid' | 'order' {
  try {
    const stored = getLocalStorage<string>(ANYA_AGENTS_VIEW_MODE, 'grid');
    return stored === 'grid' || stored === 'order' ? stored : 'grid';
  } catch {
    return 'grid';
  }
}

export function setAnyaAgentsViewMode(mode: 'grid' | 'order'): void {
  try {
    setLocalStorage(ANYA_AGENTS_VIEW_MODE, mode);
  } catch {
    // Storage unavailable — ignore
  }
}

export function getIsHighContrastModeState<T extends string>(
  defaultValue: T,
): T {
  return getLocalStorage<T>(IS_HIGH_CONTRAST_MODE, defaultValue);
}

export function setIsHighContrastModeState<T extends string>(corner: T): void {
  setLocalStorage(IS_HIGH_CONTRAST_MODE, corner);
}
